// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import { setTipoCotizacionCamposRedux, setTipoCotizacionesListRedux } from './tipoCotizacionSlice';
import {
  createTipoCotizacionService,
  getAllTipoCotizacionCamposService,
  getAllTipoCotizacionService,
  removeCamposTipoOrdenesServiciosService,
} from '../../services/tipo-cotizacion-service';
import { setFieldsOrdenesServiciosRedux } from '../ordenes-de-servicios';

export const getAllTipoCotizacionRedux = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAllTipoCotizacionService();

    dispatch(unCheckingPreload());

    if (!result.ok) return result;

    await dispatch(setTipoCotizacionesListRedux(result.data));

    return result;
  };
};

export const getAllTipoCotizacionCamposRedux = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAllTipoCotizacionCamposService();

    dispatch(unCheckingPreload());

    if (!result.ok) return result;

    console.log('resulttt ', result);
    await dispatch(setTipoCotizacionesListRedux(result.data.typeQuotitation));
    await dispatch(setFieldsOrdenesServiciosRedux(result.data.typeField));
    await dispatch(setTipoCotizacionCamposRedux(result.data.typeQuotitationTypeField));

    return result;
  };
};

export const storeCreateTipoCotizacion = (data: any, percentage: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const dataSave = {
      name: data.name,
      description: data.description,
    };

    const result = await createTipoCotizacionService(dataSave, percentage);

    if (result.ok) {
      await dispatch(setTipoCotizacionesListRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const removeCamposTipoOrdenesServicios = (parametroId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await removeCamposTipoOrdenesServiciosService(parametroId);

    dispatch(unCheckingPreload());

    return result;
  };
};

// export const getParametersStore = (): any => {

//     return async( dispatch: any ) => {

//       await dispatch( checkingPreload() );

//       const result = await  getAllParametersService();

//       ( result && result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );

//       dispatch( unCheckingPreload() );

//       if ( result.ok ) {

//         // PARAMETROS
//           // await AsyncStorage.setItem(types.storage.parametrosStorage, JSON.stringify(result.data));
//           await dispatch( setParametrosRedux(result.data) );

//       }

//       return result;

//     }
// }

// export const getParameterByPagination = (page:number): any => {

//     return async( dispatch: any ) => {

//       await dispatch( checkingPreload() );

//       const result = await  getAllParameterByPaginateService(page);

//       if ( result.ok ) {
//           await dispatch( setParametrosRedux(result.data) );
//       }

//       dispatch( unCheckingPreload() );

//       return result;

//     }

// }

// export const  storeSetParameter = async( parameters: any ) => {

//     return async( dispatch: any ) => {

//       await dispatch( setParametrosRedux(parameters) );

//     }

// }

// export const storeCreateParameter = (parameter: any, percentage:any): any => {

//     return async( dispatch: any ) => {

//       await dispatch( checkingPreload() );

//       const dataParameter = {
//         parameterId:  parameter.parameterId,
//         vista_lista:  0,
//         redondeo:  0,
//         llegadas_tarde:  parameter.llegadas_tarde,
//         salidas_tarde:  parameter.salidas_tarde,
//         salario_minimo:  parameter.salario_minimo,
//         auxilio_transporte:  parameter.auxilio_transporte,
//         interes_cesantias:  parameter.interes_cesantias,
//         year:  parameter.year,
//         cantidadHorasSemanales:  parameter.horasSemanales,
//         cantidadHorasMensuales:  parameter.horasMensuales
//       };

//       const result = await  createParameterService(dataParameter, percentage);

//       if ( result.ok ) {

//         if ( Object.keys(result.data).length > 0  ) {

//           // const dataResult:any = await addRowTblPaginate(types.storage.parametrosStorage, result.data );

//           if (result.ok) {

//               await dispatch( setParametrosRedux(result.data) );
//           }

//         }

//       }

//       dispatch( unCheckingPreload() );

//       return result;

//     }

// }

// export const storeDesactiveParametro = (parametroId: string): any => {

//   return async( dispatch: any ) => {

//       await dispatch( checkingPreload() );

//       const result = await  desactiveParameterService(parametroId);

//       dispatch( unCheckingPreload() );

//       if ( result.ok ) {

//                                            // key storage      // id element         // status
//           // const dataResult:any = await updateStatusRowTblPaginate(types.storage.parametrosStorage, parametroId, 0);

//           if (result.ok) {

//               await dispatch( setParametrosRedux(result.data) );
//           }

//       }

//       return result;

//   }

// }

// export const storeActiveParametro = (parametroId: string): any => {

//   return async( dispatch: any ) => {

//       await dispatch( checkingPreload() );

//       const result = await  activeParameterService(parametroId);

//       dispatch( unCheckingPreload() );

//       if ( result.ok ) {

//         // const dataResult:any = await updateStatusRowTblPaginate(types.storage.parametrosStorage, parametroId, 1);

//         if (result.ok) {

//             await dispatch( setParametrosRedux(result.data) );
//         }

//       }

//       return result;

//   }

// }

// export const storeDetailParameter = (parameterId: string): any => {

//   return async( dispatch: any ) => {

//       await dispatch( checkingPreload() );

//       const result = await  getParameterDetailService(parameterId);

//       dispatch( unCheckingPreload() );

//       if ( result.ok ) {

//             const dataParameter = {
//               id:  result.data.id,
//               vista_lista:  result.data.vista_lista,
//               redondeo:  result.data.redondeo,
//               llegadas_tarde:  result.data.llegadas_tarde,
//               salidas_tarde:  result.data.salidas_tarde,
//               salario_minimo:  result.data.salario_minimo,
//               auxilio_transporte:  result.data.auxilio_transporte,
//               interes_cesantias:  result.data.interes_cesantias,
//               year:  result.data.year
//             }

//             await dispatch( storeParameterRedux(dataParameter) );
//       }

//       return result;

//   }

// }

// export const storeEditParameter = (parameter: any): any => {

//   return async( dispatch: any ) => {

//       const dataParameter = {
//         parameterId:  parameter.parameterId,
//         vista_lista:  0,
//         redondeo:  0,
//         llegadas_tarde:  parameter.e_llegadas_tarde,
//         salidas_tarde:  parameter.e_salidas_tarde,
//         salario_minimo:  parameter.e_salario_minimo,
//         auxilio_transporte:  parameter.e_auxilio_transporte,
//         interes_cesantias:  parameter.e_interes_cesantias,
//         year:  parameter.e_year
//       }

//       const result = await  updateParameterDetailService(dataParameter);

//       if ( result.ok ) {

//         if ( Object.keys(result.data).length > 0  ) {

//           // const dataResult:any = await updateRowTblPaginate(types.storage.parametrosStorage, result.data );

//           if (result.ok) {

//               await dispatch( setParametrosRedux(result.data) );
//           }

//         }

//       }

//       return result;

//   }

// }
